// extracted by mini-css-extract-plugin
export default {"workouts":"styles_workouts__DlVG8","subtitle":"styles_subtitle__PXAOC","cards":"styles_cards__wGqhc","card":"styles_card__-KX10","descriptionInfo":"styles_descriptionInfo__Ye2kP"};